<template>
	<SpecialDetailPage />
</template>

<script setup>
import SpecialDetailPage from '@/pages/specialDetail/index.vue';
</script>
